const topBar = document.querySelector(".site-announcement-bar");

const setHeight = () => {
  document.documentElement.style.setProperty("--site-announcement-height", `${topBar.offsetHeight}px`);
};

document.addEventListener("DOMContentLoaded", () => {
  if (topBar) {
    const close = topBar.querySelector(".site-announcement-bar-close");

    if (close) {
      close.addEventListener("click", () => {
        topBar.remove();
        setHeight();
      });
    }

    setHeight();
    window.addEventListener("resize", setHeight);
  }
});
